import constants from "../constants";

function getToken() {
	return localStorage.getItem(constants.TOKEN_KEY);
}

function getAuthHeader() {
	const token = getToken();
	return {
		Authorization: token ? `Bearer ${token}` : "",
	};
}

export { getAuthHeader, getToken };

